import { useQuery } from '@tanstack/react-query'
import { authApiClient } from '~/lib/api-client'
import { createSessionQuery } from '~/lib/session-query'

export function useFavorites() {
  const { data: session } = useQuery(createSessionQuery())

  return useQuery({
    queryKey: ['favorites', 'list'],
    queryFn: async () => {
      const res = await authApiClient.users.me.favorites.$get({ query: {} })
      if (!res.ok) {
        if (res.status === 401) return []
        throw new Error('Failed to fetch favorites')
      }
      return res.json()
    },
    enabled: !!session?.user,
    staleTime: 1000 * 60 * 5,
  })
}
